module.exports = __webpack_public_path__ + "img/bonus@2x.9277cbca.png";